// Description: Custom JavaScript for the theme

// Fade in collection-images
document.addEventListener("DOMContentLoaded", function() {
  const images = document.querySelectorAll('.fade-in');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // observer.unobserve(entry.target); 
      } else {
        entry.target.classList.remove('is-visible');
      }
    });
  }, {
    threshold: 0.1
  });

  images.forEach(image => {
    observer.observe(image);
  });
});

// Section scrolling with touch
// const sections = document.querySelectorAll('.section');
// let currentSectionIndex = 0;
// let startY = 0;  // To store the initial Y position of a touch
// let endY = 0;    // To store the final Y position after a swipe
// let lockScroll = false; // To prevent scrolling when a swipe is in progress
//
// function scrollToSection(index) {
//   console.log("Scrolling to section: " + index);
//   if (index >= 0 && index < sections.length) {
//     const section = sections[index];
//
//     // Get the top position of the section relative to the document
//     const sectionTop = section.getBoundingClientRect().top + window.scrollY;
//
//     // Calculate the target position so that the section is in the middle of the screen
//     let scrollTo;
//     if (index === 0) {
//       scrollTo = 0;
//     } else {
//       scrollTo = sectionTop - (window.innerHeight / 2) + (section.offsetHeight / 2);
//     }
//
//     // Smooth scroll to the calculated position
//     window.scrollTo({ top: scrollTo, behavior: 'smooth' });
//
//     // Update the current section index
//     currentSectionIndex = index;
//   }
// }
//
// // Handle swipe start (touchstart)
// function handleTouchStart(event) {
//   startY = event.touches[0].clientY; // Record the starting Y position
// }
//
// // Handle swipe end (touchend)
// function handleTouchEnd(event) {
//   endY = event.changedTouches[0].clientY; // Record the ending Y position
//
//   // Calculate swipe direction
//   if (startY > endY + 50) {
//     // Swipe up (next section)
//     scrollToSection(currentSectionIndex + 1);
//   } else if (startY < endY - 50) {
//     // Swipe down (previous section)
//     scrollToSection(currentSectionIndex - 1);
//   }
// }
//
// // Handle scroll on mouse wheel (for desktop or devices with a mouse)
// function handleScroll(event) {
//   if (window.innerWidth < 768) {
//     return;
//   }
//
//   console.log("Lock: " + lockScroll);
//   if (lockScroll) return;
//   console.log('scrolling');
//   lockScroll = true;
//   if (event.deltaY > 0) {
//     scrollToSection(currentSectionIndex + 1); // Scroll down
//   } else {
//     scrollToSection(currentSectionIndex - 1); // Scroll up
//   }
//   setTimeout(() => {
//     lockScroll = false;
//   }, 500);
// }
//
// // Listen for touch events on mobile
// // window.addEventListener('touchstart', handleTouchStart);
// // window.addEventListener('touchend', handleTouchEnd);
//
// console.log("inner width: " + window.innerWidth);
// // Listen for scroll events (mouse wheel) on desktop or non-touch devices
// window.addEventListener('wheel', handleScroll);
